import React from "react";

import { TextButton } from "components/Button";
import Icon from "components/Icon";
import Text from "components/Text";
import { useAnswerContext } from "contexts/answerContext";
import useDownload from "hooks/useDownload";
import { useDownloadProject } from "queries/projects";

import styles from "./Download.scss";

const ProjectDownload = ({ textKey = "projects.download_pdf" }) => {
  const { record } = useAnswerContext();
  const mutation = useDownloadProject(record.id);
  const { onDownload, isDownloadInProgress } = useDownload(mutation);

  return (
    <TextButton
      data-download-pdf-button
      isLoading={isDownloadInProgress}
      onClick={onDownload}
      className={styles.button}
      label={
        <>
          <Icon icon="download" size="lg" />
          <span>
            <Text t={textKey} />
          </span>
        </>
      }
    />
  );
};

export default ProjectDownload;
